/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ClientsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      clients: this.store.findAll('client'),
      schools: this.store.findAll('school'),
    });
  }
}
